import React from "react"
import {Modal} from "react-bootstrap"
import styled from "styled-components"

import success from "@irati/ui/images/success.svg"
import {H2} from "@irati/ui/src/Headings"
import id from "@irati/utils/id"
import {FormattedMessage, LangLoader} from "@irati/utils/lang"
import {ACCOUNT} from "@irati-web/app/src/routeConfig"

const StyledModal = styled(Modal)`
  > .passwordSavedModal{
    margin-top: 100px;
  }
`

const StyledH2 = styled(H2)`
  padding: 85px 60px 60px;
`

const StyledImg = styled.img`
  position: absolute;
  top: -80px;
  left: calc(50% - 70px)
`

const PasswordSavedModal = (props) => {
  const idNamespace = id("password-saved-modal", props)

  return (
    <LangLoader bucket={ACCOUNT}>
      <StyledModal
        id={idNamespace}
        dialogClassName="passwordSavedModal"
        show>
        <StyledImg id={id("img-success", idNamespace)} src={success} alt="success" />
        <StyledH2
          id={id("title", idNamespace)}
          className="text-center">
          <FormattedMessage id="account.password.updateSuccessful" />
        </StyledH2>
      </StyledModal>
    </LangLoader>
  )
}

PasswordSavedModal.defaultProps = {
  onHide: () => {
  }
}

export default PasswordSavedModal
